import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Text } from 'components/base'

import { selectors as ChannelsSelectors } from 'data/channels'
import { selectors as UsersSelectors } from 'data/users'

import ChannelManagement from 'components/Channels/Settings/General/Management'
import ChannelList from 'components/Channels/List'
import ChannelsSettingsUsers from 'components/Channels/Settings/Memberships/ChannelPermissionsForm'
import ModalLink from 'components/Utils/Modal/Link'
import { CHANNEL_CREATE } from 'components/Utils/Modal/constants'
import Button from 'components/base/Button'
import { Link } from 'react-router-dom'

import providesAdminChannels from '../dataSync/providesAdminChannels'
import RoutesHelper from '../../../../helpers/RoutesHelper'
import LeaveAndExit from '../../../Channels/Settings/General/LeaveAndExit'

SettingsChannels.propTypes = {
  channels: PropTypes.object.isRequired,
  canManage: PropTypes.bool.isRequired,
}

function SettingsChannels(props) {
  const { channels, canManage } = props
  const firstChannelId = channels.first() && channels.first().id
  const [channelId, setChannelId] = React.useState(firstChannelId)

  if (
    props.adminChannelsFetchState.loading ||
    props.adminChannelsFetchState.pristine
  ) {
    return null
  }
  if (!canManage) {
    return (
      <div>
        You must be owner or admin of your organization to access these settings
      </div>
    )
  }

  return (
    <div className="flexbox scroll-y">
      <div
        className={classNames([
          'flexbox flexbox-column',
          'height-full',
          'radius-normal overflow-hidden',
          'border-small border-shade-40 padding-bottom-small',
        ])}
        style={{ width: 200, maxHeight: 'calc(100vh - 115px)' }}
      >
        <ChannelList
          style={{ maxHeight: 300 }}
          channelList={channels.toArray()}
          channelId={channelId}
          onChannelSelected={channel => setChannelId(channel.id)}
        />
        <div className="margin-top-small">
          <Link to={RoutesHelper.app()}>
            <Button.Primary
              className={classNames([
                'font-size-small',
                'margin-left-auto',
                'margin-right-auto',
              ])}
            >
              <ModalLink to={CHANNEL_CREATE}>Add a new channel</ModalLink>
            </Button.Primary>
          </Link>
        </div>
      </div>
      <div className="flex-grow margin-left-larger padding-right-normal">
        {channelId && (
          <div>
            <Text.Subtitle className="margin-bottom-larger font-weight-medium">
              General channel settings
            </Text.Subtitle>
            <ChannelManagement channelId={channelId} />

            <ChannelsSettingsUsers
              channelId={channelId}
              style={{ padding: 0 }}
            />
            <Text.Subtitle className="margin-top-larger font-weight-medium">
              Dangerous actions
            </Text.Subtitle>
            <LeaveAndExit channelId={channelId} canManage={canManage} />
          </div>
        )}
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  canManage: UsersSelectors.canCurrentUserManageChannels(state),
  channels: ChannelsSelectors.getAdminChannels(state),
})

export default compose(
  providesAdminChannels,
  connect(mapStateToProps)
)(SettingsChannels)
